import { Component, Prop, Emit, Watch, Vue } from "vue-property-decorator";
import { Action, Getter, State, Mutation } from "vuex-class";
import { cityParser } from "@/plugins/city_parser";
import Loading from '@/components/loading/loading';
import { isAlreadyBought } from '@/plugins/products_helper';
import CashbackTooltip from "@/components/cashbackTooltip/cashbackTooltip";
import BellNotification from "@/components/bellNotification/bellNotification";

@Component({
  components: {
    Loading,
    CashbackTooltip,
    BellNotification
  }
})
export default class CommerceProduct extends Vue {
  @Prop({ default: () => {} }) product;
  @Prop({ default: () => {} }) category!: Object;

  // Actions
  @Action action_addCartProducts: any;
  @Action action_removeCartProducts: any;
  @Action action_postCart: any;

  // Getters
  @Getter getCart: any;
  @Getter getCartTemporal: any;
  @Getter getCountry: any;
  @Getter getCity: any;
  @Getter getOpenCouponModal: any;
  @Getter getUser: any;
  @Getter getTraits: any;
  @Getter getBoughtProducts: any;
  @Getter getIsToken: any
  @Getter getIsUnderMobile;

  // Mutations
  @Mutation CART_TEMPORAL: any;
  @Mutation OPEN_COUPON_MODAL: any;
  @Mutation OPEN_CART: any;
  @Mutation PATH_TEMPORAL: any;
  @Mutation OPEN_PROMO_EXCEEDED_MODAL: any
  @Mutation LAST_PROMO_EXCEEDED_PRODUCT: any

  isBtnLoad = false;
  isAlreadyBought = false;
  isTooltipVisible = false;
  isImgLoad = true;
  isBellActive = false;
  isAlreadyActive = false;

  get geActiveProdcut() {
    const cart = this.getCartTemporal;
    const index = cart.findIndex((item )=> item.product.id === (this.product as any).id);
    return index === -1 || false;
  }

  get getQuantity() {
    if (this.getCart && this.getCart.cart_products) {
      const cart = this.getCart.cart_products;
      const index = cart.findIndex((item )=> item.product_id === (this.product as any).id);
      if (index !== -1 && cart[index] && cart[index].quantity_total) {
        return cart[index].quantity_total;
      }
    }
    return 0;
  }

  get getPrice() {
    const price = parseFloat((this.product as any).price);
    return this._money(price);
  }

  get getDiscountPrice() {
    const price =
      parseFloat((this.product as any).price) - parseFloat((this.product as any).discount);
    return this._money(price);
  }

  get getImageFilter() {
    return (this.product as any).is_activated ? "0%" : "100%";
  }

  get getIsAlreadyBought() {
    let response = isAlreadyBought(this.product.id);
    
    return response ;
  }

  get getProductPicture() {
    let response = "";
    if (this.product && this.product.product_picture && this.product.product_picture.url) {
      response = this.product.product_picture.url;
    } else if (
      this.product &&
      this.product.product_banners &&
      this.product.product_banners[0] &&
      this.product.product_banners[0].product_picture
    ) {
      response = this.product.product_banners[0].product_picture;
    }
    return response;
  }

  _verifyActive() {
    if(this.getIsToken) {
      for(let item of this.getUser.notification_available_products) {
        if(item === this.product.id) {
          return true
        }    
      }
    } else {
        return false
    }
  }

  mounted() {
    this._isOpenCouponModal();
    if(this.product && this.product.id) {
      this.isAlreadyBought = isAlreadyBought(this.product.id);
    }
    this._verifyActive()
  }

  _isOpenCouponModal() {
    this.OPEN_CART(this.getOpenCouponModal);
    this.OPEN_COUPON_MODAL(this.getOpenCouponModal);
    this.PATH_TEMPORAL({});
  }

  getProductDiscount() {
    if ((this.product as any).current_promo && (this.product as any).current_promo.promo_amount) {
      const discountValue = (this.product as any).current_promo.promo_amount.split(".")[0];
      if ((this.product as any).current_promo.promo_type === "percentage") {
        return "-" + discountValue + "%";
      } else if ((this.product as any).current_promo.promo_type === "amount") {
        const toCurrency = this.$currency.format(discountValue, { code: this.getCountry.currency });
        return "-" + toCurrency.split(',')[0];
      }
    } else {
      return false;
    }
  }

  _routerProduct() {
    this.$router.push({ name: "product", params: { id: (this.product as any).id } });
  }

  async _add(product) {
    this.isBtnLoad = true;
    try {
      const requestObject = {
        products: [
          {
            product_id: product.id,
            qty: 1
          }
        ],
        commerce_id: this.getCity.id
      };
      if (this.getCart) {
        await this.action_addCartProducts(requestObject);
      } else {
        await this.action_postCart(requestObject);
      }
    } catch (error) {
      if (error.data && error.data.message) {
        this.$swal({
          title: "Error",
          text: "¡Ups! Tuvimos un problema agregando tu producto. Por favor intenta de nuevo"
        });
      }
    }
    this.isBtnLoad = false;
  }

  async _remove(product) {
    this.isBtnLoad = true;
    try {
      const requestObject = {
        products: [
          {
            product_id: product.id,
            qty: 1,
            type: 'remove'
          }
        ],
        commerce_id: this.getCity.id
      };
      if (this.getCart) {
        await this.action_removeCartProducts(requestObject);
      } else {
        await this.action_postCart(requestObject);
      }
    } catch (error) {
      if (error.data && error.data.message) {
        this.$swal({
          title: "Error",
          text: "¡Ups! Tuvimos un problema removiendo tu producto. Por favor intenta de nuevo"
        });
      }
    }
    this.isBtnLoad = false;
  }

  goToProfile(productId) {
    const route = this.$route;
    if(this.getCity && this.getCity.commercial_name) {
      const cityId = cityParser(this.getCity.commercial_name);
      if(route && route.name && route.name !== 'productDetail') {
        this.$router.push({
          name: "productDetail",
          params: { city_id: cityId, product_id: productId }
        });
      } else {
        try {
          const paramProdId = route.params.product_id;
          if(paramProdId != productId) {
            this.$router.replace({ params: {
              city_id: cityId,
              product_id: productId
            }});
          }
        } catch (err) {
          
        }
      }
    }
    
  }

  activeBellAlert() {
    this.isBellActive = true;
  }

  noActiveBellAlert() {
    this.isBellActive = false;
  }

  _validateId(idProduct) {
    let item
    for(item in this.getUser.notification_available_products) {
      if(item == idProduct) {
        this.isAlreadyActive == true;
      }
    }
    console.log(this.isAlreadyActive);
    
  }

  _routeCheckout() {
    this.$router.push({ name: "checkout" });
    // @ts-ignore
    this.$ga.event("Pedido", "Comercio", "Pedir ya");
  }

  _goToCashbackInfo() {
    
  }

  get getDiscountLabel() {
    let response = "";
    if (
      this.product &&
      this.product.current_promo &&
      this.product.current_promo.promo_type &&
      this.product.current_promo.promo_type.length &&
      this.product.current_promo.promo_amount > 0
    ) {
      const promoType = this.product.current_promo.promo_type;
      const promoAmount = this.product.current_promo.promo_amount;
      if(promoType === 'percentage') {
        response = `${parseInt(promoAmount)}% OFF`;
      } else if (promoType === 'amount') {
        response = `-${this._money(promoAmount)}`;
      }
    }
    return response;
  }

  _truncate(value: string) {
    let response = value;
    let maxChars = 25;
    if(this.getIsUnderMobile) {
      maxChars = 20;
    }
    if(value && value.length && value.length > maxChars) {
      response = value.substr(0, maxChars) + "...";
    }
    return response;
  }

  _money(val) {
    const formatter = new Intl.NumberFormat(undefined, {
      style: 'decimal',
      currency: this.getCountry.currency,
      maximumFractionDigits: 0,
      minimumFractionDigits: 0
    });
    return `$ ${formatter.format(val)}` ;
  }

  get tooltipMessage() {
    let response = "";
    if (this.getIsToken) {
      response =
        "Aún no has probado este producto." +
        " <br /><b>¡Atrévete!</b>" +
        " y si no te gusta, <b>te devolvemos tu dinero en cashback.</b>";
    } else {
      response =
        "Te devolvemos el dinero de los productos que pruebes por primera vez y no te gusten." +
        " Al iniciar sesión sabrás cuales son.";
    }
    return response;
  }
}
